<template>
  <form style=" z-index: 1; position: relative;">
      <v-row align="start" class="mt-0 mt-md-3 mb-0"  :key="componentKey">
         <v-col class="d-flex ml-0 ml-md-4 ml-lg-4 my-0 py-0"  cols="12" sm="3"  md="3" lg="2" xl="2">
            <v-select
                id="inputYear"
                v-model="selectedYear"
                :items="years"
                 @change="onChangeYear()"
                item-value='value'
                item-text='label'
                label="Year"
                outlined
                dense
                require
            ></v-select>
        </v-col>

        <v-col v-if="showType" class="d-flex my-0 py-0" cols="12"  sm="3" md="3" lg="2">
            <v-select
                id="inputType"
                v-model="selectedType"
                :items="typePublication"
                item-value='id'
                item-text='name'
                label="Type"
                outlined
                dense
                required
            ></v-select>
        </v-col>
    </v-row>
    <v-row align="start" class="my-0 "  style=" z-index: 10; position: relative;">
        <v-col class="d-flex mt-n3 py-0 mb-2" cols="12" md="2" lg="2" >
            <v-btn v-if="loading" loading small class="mt-0 ml-0 ml-md-4 ml-lg-4 blue darken-4 text-white"  >-</v-btn>
            <v-btn v-else small class="mt-0 ml-0 ml-md-4 ml-lg-4 blue darken-4 text-white"  @click="getFilteredPublications">
                Search
            </v-btn>
        </v-col>
    </v-row>
  </form>
</template>

<script>

import {mapGetters} from 'vuex';
import {mapActions} from 'vuex';
const  yyyy = new Date().getFullYear() + 1;
export default {
    props:{
        showType:Boolean,
        typeProduction:String,
        id:Number,
        bo: { type:Boolean,
                default:false
        },
    },
    data(){
        var label ="Author";
        var selectedTypeValue = 20;
        return{
            selectedYear:1,
            selectedDepartment:0,
            selectedGrant:0,
            selectedMember:this.id,
            selectedInvestigator:0,
            years:[],
            label:label,
            selectedType:selectedTypeValue,
            componentKey:0,
        }
    },
    created(){
       this.allDataLoaders = Promise.all([
            this.getYears(1960),
            this.getFilteredPublications(),
        ]);
        this.signalDataUpdate();

    },
   computed:{
        ...mapGetters('publication',{
            typePublication:'typePublication',
            year:'year',
            loading:'loading'
        }),
    },
    methods:{
        ...mapActions('publication',{
            setPublications:'setPublications',
            setYear:'setYear',
        }),
        async signalDataUpdate() {
            // Make sure all the needed data has been retrieved.
            await this.allDataLoaders;
            this.componentKey=this.componentKey+'1';
        },
        onChangeYear(){
            this.setYear(this.selectedYear);
        },
        getYears(start){
            var options = [{value:1,label:'recent 5 publications'},
            {value:0,label:'all'},
            {value:2100,label:'to appear'},];
            for (let i = yyyy; i >= start; i--) {
                options.push({value:i,label:i.toString()});
            }
            this.years = options;
        },
        getFilteredPublications(){
            var criterias={};
            criterias.selectedYear= this.selectedYear;
            criterias.selectedDepartment = 0;
            criterias.selectedMember = this.id;

            criterias.selectedGrant = 0;
            criterias.selectedInvestigator = 0;
            criterias.idDepartmentGrants = 0;
            criterias.selectedType = this.selectedType;
            if(this.typeProduction == 'lectures'){
               criterias.selectedType = 8;
            }
            this.setPublications(criterias);
        }
    },
}
</script>
<style scoped>
.v-input {
    align-items: flex-start;
    display: flex;
    flex: 1 1 auto;
    font-size: 14px !important;
    letter-spacing: normal;
    max-width: 100%;
    text-align: left;
}
.form-select{
    width:100%;
}
</style>

